<template>
    <div>
        <v-tooltip left v-if="showButtons.edit">
            <template v-slot:activator="{ on }">
                <v-btn 
                    class="btnActions"
                    icon 
                    small 
                    outlined
                    v-on="on" 
                    :to="{ name: link, params: { id: id }}"
                >
                    <v-icon small @click="customActionEdit(id)">mdi-pencil</v-icon>
                </v-btn>
            </template>
            <span>Edit</span>
        </v-tooltip>

        <v-tooltip left v-if="showButtons.delete">
            <template v-slot:activator="{ on }">
                <v-btn 
                    class="btnActions"
                    icon 
                    small 
                    outlined
                    v-on="on"
                >
                    <v-icon small @click="confirmDelete(id)">mdi-delete</v-icon>
                </v-btn>
            </template>
            <span>Delete</span>
        </v-tooltip>

        <v-tooltip left v-if="showButtons.cancel">
            <template v-slot:activator="{ on }">
                <v-btn 
                    class="btnActions"
                    icon 
                    small 
                    outlined
                    v-on="on"
                >
                    <v-icon small @click="confirmCancel(id)">mdi-flask-empty-off</v-icon>
                </v-btn>
            </template>
            <span>Inactive</span>
        </v-tooltip>

        <v-tooltip left v-if="showButtons.active">
            <template v-slot:activator="{ on }">
                <v-btn 
                    class="btnActions"
                    icon 
                    small 
                    outlined
                    v-on="on"
                >
                    <v-icon small @click="confirmActive(id)">mdi-account-reactivate-outline</v-icon>
                </v-btn>
            </template>
            <span>Active</span>
        </v-tooltip>

        <v-tooltip left v-if="showButtons.approve">
            <template v-slot:activator="{ on }">
                <v-btn 
                    class="btnActions"
                    icon 
                    small 
                    outlined
                    v-on="on"
                >
                    <v-icon small @click="confirmApprove(id)">mdi-account-check-outline</v-icon>
                </v-btn>
            </template>
            <span>Approve</span>
        </v-tooltip>

        <v-tooltip left v-if="showButtons.resetPassword">
            <template v-slot:activator="{ on }">
                <v-btn 
                    class="btnActions"
                    icon 
                    small 
                    outlined
                    v-on="on"
                >
                    <v-icon small @click="confirmResetPassword(id)">mdi-lock-reset</v-icon>
                </v-btn>
            </template>
            <span>Reset User Password</span>
        </v-tooltip>

        <v-tooltip left v-if="showButtons.viewToDo">
            <template v-slot:activator="{ on }">
                <v-btn 
                    class="btnActions"
                    icon 
                    small 
                    outlined
                    v-on="on"
                >
                    <v-icon small @click="viewToDo(id)">mdi-email-check-outline</v-icon>
                </v-btn>
            </template>
            <span>View To-Do</span>
        </v-tooltip>

        <v-tooltip left v-if="showButtons.markDoneUnDone">
            <template v-slot:activator="{ on }">
                <v-btn 
                    class="btnActions"
                    icon 
                    small 
                    outlined
                    v-on="on"
                >
                    <v-icon small @click="confirmDoneUnDone(id)">mdi-check</v-icon>
                </v-btn>
            </template>
            <span>Mark as Done</span>
        </v-tooltip>

        <v-tooltip left v-if="showButtons.clone">
            <template v-slot:activator="{ on }">
                <v-btn 
                    class="btnActions"
                    icon 
                    small 
                    outlined
                    v-on="on"
                >
                    <v-icon small @click="confirmClone(id)">mdi-content-duplicate</v-icon>
                </v-btn>
            </template>
            <span>Clone</span>
        </v-tooltip>

        <v-tooltip left v-if="showButtons.assignSalesPerson">
            <template v-slot:activator="{ on }">
                <v-btn 
                    class="btnActions"
                    icon 
                    small 
                    outlined
                    v-on="on"
                >
                    <v-icon small @click="assignSalesPerson(id)">mdi-clipboard-account-outline</v-icon>
                </v-btn>
            </template>
            <span>Assign Sales Person</span>
        </v-tooltip>

        <v-tooltip left v-if="showButtons.cancel2">
            <template v-slot:activator="{ on }">
                <v-btn 
                    class="btnActions"
                    icon 
                    small 
                    outlined
                    v-on="on"
                >
                    <v-icon small @click="confirmCancel2(id)">mdi-cancel</v-icon>
                </v-btn>
            </template>
            <span>Cancel</span>
        </v-tooltip>

        <v-tooltip left v-if="showButtons.markStarted">
            <template v-slot:activator="{ on }">
                <v-btn 
                    class="btnActions"
                    icon 
                    small 
                    outlined
                    v-on="on"
                >
                    <v-icon small @click="confirmMarkAsStarted(id)">mdi-calendar-start-outline</v-icon>
                </v-btn>
            </template>
            <span>Mark as Started</span>
        </v-tooltip>

        <v-tooltip left v-if="showButtons.markFailed">
            <template v-slot:activator="{ on }">
                <v-btn 
                    class="btnActions"
                    icon 
                    small 
                    outlined
                    v-on="on"
                >
                    <v-icon small @click="confirmMarkAsFailed(id)">mdi-thumb-down-outline</v-icon>
                </v-btn>
            </template>
            <span>Mark as Incomplete</span>
        </v-tooltip>

        <v-tooltip left v-if="showButtons.deny">
            <template v-slot:activator="{ on }">
                <v-btn 
                    class="btnActions"
                    icon 
                    small 
                    outlined
                    v-on="on"
                >
                    <v-icon small @click="confirmDeny(id)">mdi-thumb-down-outline</v-icon>
                </v-btn>
            </template>
            <span>Deny</span>
        </v-tooltip>

        <v-tooltip left v-if="showButtons.schedule">
            <template v-slot:activator="{ on }">
                <v-btn 
                    class="btnActions"
                    icon 
                    small 
                    outlined
                    v-on="on"
                >
                    <v-icon small @click="confirmSchedule(id)">mdi-calendar-start-outline</v-icon>
                </v-btn>
            </template>
            <span>Schedule</span>
        </v-tooltip>

        <v-tooltip left v-if="showButtons.hold">
            <template v-slot:activator="{ on }">
                <v-btn 
                    class="btnActions"
                    icon 
                    small 
                    outlined
                    v-on="on"
                >
                    <v-icon small @click="confirmHold(id)">mdi-car-brake-hold</v-icon>
                </v-btn>
            </template>
            <span>On Hold</span>
        </v-tooltip>

        <v-tooltip left v-if="showButtons.resume">
            <template v-slot:activator="{ on }">
                <v-btn 
                    class="btnActions"
                    icon 
                    small 
                    outlined
                    v-on="on"
                >
                    <v-icon small @click="confirmResume(id)">mdi-play-circle-outline</v-icon>
                </v-btn>
            </template>
            <span>Resume</span>
        </v-tooltip>

        <v-tooltip left v-if="showButtons.check">
            <template v-slot:activator="{ on }">
                <v-btn 
                    class="btnActions"
                    icon 
                    small 
                    outlined
                    v-on="on"
                >
                    <v-icon small @click="confirmCheck(id)">mdi-text-box-check-outline</v-icon>
                </v-btn>
            </template>
            <span>Check</span>
        </v-tooltip>

        <v-tooltip left v-if="showButtons.download">
            <template v-slot:activator="{ on }">
                <v-btn 
                    class="btnActions"
                    icon 
                    small 
                    outlined
                    v-on="on"
                >
                    <v-icon small @click="confirmDownload(id)">mdi-file-download-outline</v-icon>
                </v-btn>
            </template>
            <span>Download</span>
        </v-tooltip>

        <v-tooltip left v-if="showButtons.notes">
            <template v-slot:activator="{ on }">
                <v-btn 
                    class="btnActions"
                    icon 
                    small 
                    outlined
                    v-on="on"
                >
                    <v-icon small @click="confirmNotes(id)">mdi-chat-alert-outline</v-icon>
                </v-btn>
            </template>
            <span>Communication for the customer</span>
        </v-tooltip>

        <v-tooltip left v-if="showButtons.payments">
            <template v-slot:activator="{ on }">
                <v-btn 
                    class="btnActions"
                    icon 
                    small 
                    outlined
                    v-on="on"
                >
                    <v-icon small @click="confirmPayments(id)">mdi-account-credit-card</v-icon>
                </v-btn>
            </template>
            <span>Check Payments</span>
        </v-tooltip>

        <v-tooltip left v-if="showButtons.viewPaymentsDetails">
            <template v-slot:activator="{ on }">
                <v-btn 
                    class="btnActions"
                    icon 
                    small 
                    outlined
                    v-on="on"
                >
                    <v-icon small @click="viewPaymentsDetails(id)">mdi-credit-card-settings-outline</v-icon>
                </v-btn>
            </template>
            <span>View Payments Details</span>
        </v-tooltip>

        <v-tooltip left v-if="showButtons.viewPhotos">
            <template v-slot:activator="{ on }">
                <v-btn 
                    class="btnActions"
                    icon 
                    small 
                    outlined
                    v-on="on"
                >
                    <v-icon small @click="viewPhotos(id)">mdi-view-gallery-outline</v-icon>
                </v-btn>
            </template>
            <span>View Photos / Files</span>
        </v-tooltip>

        <v-tooltip left v-if="showButtons.close">
            <template v-slot:activator="{ on }">
                <v-btn 
                    class="btnActions"
                    icon 
                    small 
                    outlined
                    v-on="on"
                >
                    <v-icon small @click="confirmClose(id)">mdi-check-all</v-icon>
                </v-btn>
            </template>
            <span>Close</span>
        </v-tooltip>

        <v-tooltip left v-if="showButtons.tryAgain">
            <template v-slot:activator="{ on }">
                <v-btn 
                    class="btnActions"
                    icon 
                    small 
                    outlined
                    v-on="on"
                >
                    <v-icon small @click="confirmTryAgain(id)">mdi-file-sync-outline</v-icon>
                </v-btn>
            </template>
            <span>Integrate Again</span>
        </v-tooltip>

        <v-tooltip left v-if="showButtons.view">
            <template v-slot:activator="{ on }">
                <v-btn 
                    class="btnActions"
                    icon 
                    small 
                    outlined
                    v-on="on"
                >
                    <v-icon small @click="confirmView(id)">mdi-history</v-icon>
                </v-btn>
            </template>
            <span>View History</span>
        </v-tooltip>

        <v-tooltip left v-if="showButtons.viewDetails">
            <template v-slot:activator="{ on }">
                <v-btn 
                    class="btnActions"
                    icon 
                    small 
                    outlined
                    v-on="on"
                >
                    <v-icon small @click="confirmViewDetails(id)">mdi-text-box-search-outline</v-icon>
                </v-btn>
            </template>
            <span>View Details</span>
        </v-tooltip>

        <v-tooltip left v-if="showButtons.addClientConsideration">
            <template v-slot:activator="{ on }">
                <v-btn 
                    class="btnActions"
                    icon 
                    small 
                    outlined
                    v-on="on"
                >
                    <v-icon small @click="confirmAddClientConsideration(id)">mdi-face-agent</v-icon>
                </v-btn>
            </template>
            <span>Add Client Considerations</span>
        </v-tooltip>

        <v-tooltip left v-if="showButtons.checkSignature">
            <template v-slot:activator="{ on }">
                <v-btn 
                    class="btnActions"
                    icon 
                    small 
                    outlined
                    v-on="on"
                >
                    <v-icon small @click="confirmCheckSignature(id)">mdi-file-sign</v-icon>
                </v-btn>
            </template>
            <span>Check Signatures</span>
        </v-tooltip>

        <div style="display: flex; flex-direction: column;" v-if="showButtons.upDown">
            <v-tooltip left>
                <template v-slot:activator="{ on }">
                    <v-btn 
                        class="btnActionsWithoutBorder"
                        icon 
                        small 
                        outlined
                        v-on="on"
                        @click.stop=""
                    >
                        <v-icon small @click="confirmUp(id)" @click.stop="">mdi-menu-up</v-icon>
                    </v-btn>
                </template>
                <span>Change Order Up</span>
            </v-tooltip>

            <v-tooltip left>
                <template v-slot:activator="{ on }">
                    <v-btn 
                        class="btnActionsWithoutBorder"
                        icon 
                        small 
                        outlined
                        v-on="on"
                        @click.stop=""
                    >
                        <v-icon small @click="confirmDown(id)" @click.stop="">mdi-menu-down</v-icon>
                    </v-btn>
                </template>
                <span>Change Order Down</span>
            </v-tooltip>
        </div>

        <v-tooltip left v-if="showButtons.sendApprove">
            <template v-slot:activator="{ on }">
                <v-btn 
                    class="btnActions"
                    icon 
                    small 
                    outlined
                    v-on="on"
                >
                    <v-icon small @click="confirmSendApprove(id)">mdi-invoice-text-send-outline</v-icon>
                </v-btn>
            </template>
            <span>Send For Approval</span>
        </v-tooltip>

        <v-tooltip left v-if="showButtons.productArrived">
            <template v-slot:activator="{ on }">
                <v-btn 
                    class="btnActions"
                    icon 
                    small 
                    outlined
                    v-on="on"
                >
                    <v-icon small @click="confirmProductArrived(id)">mdi-package-variant-closed-check</v-icon>
                </v-btn>
            </template>
            <span>Product Arrived?</span>
        </v-tooltip>

        <ActionResetUserPassword 
            :showDialogResetUserPassword.sync="dialogResetUserPassword.show"
            :id="dialogResetUserPassword.id"
        />

        <ViewToDo 
            :showDialogViewToDo.sync="dialogViewToDo.show"
            :id="dialogViewToDo.id"
        />

        <AssignSalesPerson 
            v-on:methodToCall="dialogAssignSalesPerson.methodUpdate"
            :showDialogAssignSalesPerson.sync="dialogAssignSalesPerson.show"
            :id="dialogAssignSalesPerson.id"
        />
        
    </div>
</template>

<script>
    import ActionResetUserPassword from "@/components/Layout/ActionResetUserPassword";
    import ViewToDo from "@/components/ToDo/ViewToDo";
    import AssignSalesPerson from "@/components/Services/AssignSalesPerson";

    export default {

        components: {
            ActionResetUserPassword: ActionResetUserPassword,
            ViewToDo,
            AssignSalesPerson
        },

        props: {
            link: {
                type: String,
                default: ""
            }, 

            id: {
                type: Number,
                default : 0
            },

            showButtons: {
                type: Object,
                edit: true,
                delete: true,
                cancel: true,
                cancel2: true,
                active: true,
                approve: true,
                resetPassword: true,
                viewToDo: true,
                markDoneUnDone: true,
                clone: true,
                assignSalesPerson: true,
                download: true,
                markStarted: true,
                markFailed: true,
                deny: true,
                schedule: true,
                hold: true,
                resume: true,
                check: true,
                notes: true,
                payments: true,
                viewPaymentsDetails: true,
                viewPhotos: true,
                close: true,
                view: true,
                viewDetails: true,
                addClientConsideration: true,
                checkSignature: true,
                tryAgain: true,
                upDown: true,
                sendApprove: true,
                productArrived: true,
            }
        },

        data: () => ({

            dialogResetUserPassword: {
                show: false,
                id: 0
            },

            dialogViewToDo: {
                show: false,
                id: 0
            },

            dialogAssignSalesPerson: {
                methodUpdate: ( () => {} ),
                show: false,
                id: 0
            },
        }),

        methods: {
            customActionEdit(id) {
                this.$emit("customActionEdit", id);
            },

            confirmDelete(id) {
                this.$emit("confirmDelete", id);
            },

            confirmCancel(id) {
                this.$emit("confirmCancel", id);
            },

            confirmCancel2(id) {
                this.$emit("confirmCancel2", id);
            },

            confirmActive(id) {
                this.$emit("confirmActive", id);
            },

            confirmApprove(id) {
                this.$emit("confirmApprove", id);
            },

            confirmResetPassword(id) {

                this.dialogResetUserPassword = {
                    show: true,
                    id: id
                };
            },

            viewToDo(id) {
                this.dialogViewToDo = {
                    show: true,
                    id: id
                };
                
                this.$emit("viewToDo", id);
            },

            confirmDoneUnDone(id) {
                this.$emit("confirmDoneUnDone", id);
            },

            confirmClone(id) {
                this.$emit("confirmClone", id);
            },

            assignSalesPerson(id) {
                this.dialogAssignSalesPerson = {
                    methodUpdate: this.assignSalesPersonBack,
                    show: true,
                    id: id
                };
            },

            assignSalesPersonBack() {
                this.$emit("assignSalesPerson")
            },

            confirmDownload(id) {
                this.$emit("confirmDownload", id);
            },

            confirmMarkAsStarted(id) {
                this.$emit("confirmMarkAsStarted", id);
            },

            confirmMarkAsFailed(id) {
                this.$emit("confirmMarkAsFailed", id);
            },

            confirmDeny(id) {
                this.$emit("confirmDeny", id);
            },

            confirmSchedule(id) {
                this.$emit("confirmSchedule", id);
            },

            confirmHold(id) {
                this.$emit("confirmHold", id);
            },

            confirmResume(id) {
                this.$emit("confirmResume", id);
            },

            confirmCheck(id) {
                this.$emit("confirmCheck", id);
            },

            confirmNotes(id) {
                this.$emit("confirmNotes", id);
            },

            confirmPayments(id) {
                this.$emit("confirmPayments", id);
            },

            viewPaymentsDetails(id) {
                this.$emit("viewPaymentsDetails", id);
            },

            viewPhotos(id) {
                this.$emit("viewPhotos", id);
            },

            confirmClose(id) {
                this.$emit("confirmClose", id);
            },

            confirmView(id) {
                this.$emit("confirmView", id);
            },

            confirmViewDetails(id) {
                this.$emit("confirmViewDetails", id);
            },

            confirmAddClientConsideration(id) {
                this.$emit("confirmAddClientConsideration", id);
            },

            confirmCheckSignature(id) {
                this.$emit("confirmCheckSignature", id);
            },

            confirmTryAgain(id) {
                this.$emit("confirmTryAgain", id);
            },

            confirmUp(id) {
                this.$emit("confirmUp", id);
            },

            confirmDown(id) {
                this.$emit("confirmDown", id);
            },

            confirmSendApprove(id) {
                this.$emit("confirmSendApprove", id);
            },

            confirmProductArrived(id) {
                this.$emit("confirmProductArrived", id);
            },
        }
    };
</script>